export default {
  label: {
    listening: {
      title: 'Filtro no propietario',
      notClassified: 'No Clasificados',
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Etiquetas',
    },
    sac: {
      title: 'Filtro propietario',
    },
    page: {
      title: 'Filtro de páginas',
    },
    sacStatus: {
      title: 'Filtro de atención',
      descriptionPart1: 'Los filtros del componente tienen preferencia sobre los globales. Nota: el filtro ',
      descriptionPart2: ' no sobrescribe el filtro global de estado. El filtro ',
      descriptionPart3: ' sobrescribe el filtro global de estado.',
      statusTransitionOld: 'Transición de estado (antigua)',
      statusTransitionNew: 'Transición de estado (nueva)',
      statusTransitionCurrent: 'Transición de estado (actual)',
    },
    comparative: {
      title: 'Filtro comparativo',
      notClassified: 'No Clasificados',
      groupsLabel: 'Grupos',
    },
    category: {
      title: 'Categoría',
      placeholder: 'Ninguno',
    },
    tagView: {
      title: 'Vista de etiquetas',
      button_clear: 'Limpiar vista',
    },
    sacListening: {
      title: 'Filtro propietario + no propietario',
      listeningSession: 'No propietarios',
      sacSession: 'Propietarios',
      notClassified: 'No Clasificados',
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Etiquetas',
    },
    sacFilter: {
      notClassified: 'No Clasificados',
      groups: 'Grupos',
      noGroups: 'Sin grupos',
      themes: 'Temas',
      tags: 'Etiquetas',
      repliers: 'Agentes',
      status: 'Estado',
    },
    blip: {
      title: 'Filtro Blip',
      channels: 'Canales',
      queues: 'Colas',
      attendants: 'Agentes',
      tags: 'Etiquetas',
      scheduling: 'Programación',
      campaignName: 'Nombre de Campaña',
    },
    generic: {
      notClassified: 'No Clasificados',
      groups: 'Grupos',
      themes: 'Temas',
      tags: 'Etiquetas',
    },
    button: {
      applyLabel: 'Aplicar',
      clearFilter: 'Limpiar todos los filtros',
      clearchange: 'Revertir cambios recientes',
    },
    dataTypeLabel: {
      listening: 'Datos no propietarios',
      sac: 'Datos propietarios',
      page: 'Métricas de páginas',
      blip: 'BLIP',
      'sac-listening': 'Propietarios + No propietarios',
      custom: 'Personalizados',
      static: 'Complementarios',
      'sac-status': 'Smart Care',
      filterPrefix: 'Filtro',
    },
  },
};
